"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcTransactionStatusConstants = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var BcTransactionStatusConstants = (function () {
    function BcTransactionStatusConstants() {
    }
    var _a;
    _a = BcTransactionStatusConstants;
    BcTransactionStatusConstants.BC_TRANSACTION_STATUS_CLASS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-transaction-status");
    BcTransactionStatusConstants.BC_TRANSACTION_STATUS_SUCCESS = "".concat(_a.BC_TRANSACTION_STATUS_CLASS, "-success");
    BcTransactionStatusConstants.BC_TRANSACTION_STATUS_ERROR = "".concat(_a.BC_TRANSACTION_STATUS_CLASS, "-error");
    BcTransactionStatusConstants.BC_TRANSACTION_STATUS_WARNING = "".concat(_a.BC_TRANSACTION_STATUS_CLASS, "-warning");
    BcTransactionStatusConstants.BC_TRANSACTION_STATUS_INFO = "".concat(_a.BC_TRANSACTION_STATUS_CLASS, "-info");
    BcTransactionStatusConstants.BC_TRANSACTION_STATUS_GENERIC = "".concat(_a.BC_TRANSACTION_STATUS_CLASS, "-generic");
    BcTransactionStatusConstants.BC_TRANSACTION_STATUS_DYNAMIC = "".concat(_a.BC_TRANSACTION_STATUS_CLASS, "-dynamic");
    BcTransactionStatusConstants.BC_TRANSACTION_STATUS_SIZE_2XS = "".concat(_a.BC_TRANSACTION_STATUS_CLASS, "-2xs");
    BcTransactionStatusConstants.BC_TRANSACTION_STATUS_SIZE_SM = "".concat(_a.BC_TRANSACTION_STATUS_CLASS, "-sm");
    BcTransactionStatusConstants.BC_TRANSACTION_STATUS_SIZE_MD = "".concat(_a.BC_TRANSACTION_STATUS_CLASS, "-md");
    BcTransactionStatusConstants.BC_TRANSACTION_STATUS_SIZE_LG = "".concat(_a.BC_TRANSACTION_STATUS_CLASS, "-lg");
    BcTransactionStatusConstants.BC_TRANSACTION_STATUS_SIZE_XL = "".concat(_a.BC_TRANSACTION_STATUS_CLASS, "-xl");
    BcTransactionStatusConstants.BC_ICON_CLASS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-icon");
    BcTransactionStatusConstants.BC_ICON_SIZE_2XS = "".concat(_a.BC_ICON_CLASS, "-2xs");
    BcTransactionStatusConstants.BC_ICON_SIZE_SM = "".concat(_a.BC_ICON_CLASS, "-sm");
    BcTransactionStatusConstants.BC_ICON_SIZE_MD = "".concat(_a.BC_ICON_CLASS, "-md");
    BcTransactionStatusConstants.BC_ICON_SIZE_LG = "".concat(_a.BC_ICON_CLASS, "-lg");
    BcTransactionStatusConstants.BC_ICON_TYPE_CHECK = "check";
    BcTransactionStatusConstants.BC_ICON_TYPE_ERROR = "error";
    BcTransactionStatusConstants.BC_ICON_TYPE_WARNING = "hand-five";
    BcTransactionStatusConstants.BC_ICON_TYPE_INFO = "lightbulb";
    BcTransactionStatusConstants.BC_ICON_TYPE_GENERIC = "megaphone";
    return BcTransactionStatusConstants;
}());
exports.BcTransactionStatusConstants = BcTransactionStatusConstants;
